export function isError(value: any): value is Error {
  return value instanceof Error;
}

export function formatJsError(error: any, stackTrace = false) {
  if (isError(error)) {
    return `${error.name}: ${error.message}${stackTrace ? `\n${error.stack}` : ""}`;
  }
  return error;
}
